import React from 'react';
const signalR = require("@microsoft/signalr");

// const jwt = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJzdXBlcmFkbWluIiwidXNlcklkIjoxLCJleHAiOjE2MzkwODA5MDksImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6NTAwMCIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6MzAwMCJ9.9kLNALI9g-lsePrn5BV-p-os-2u8NZfYkhv0YvSshRM";
// let jwt = "";
// const connection = new signalR.HubConnectionBuilder()
//     .withUrl("https://localhost:5001/SignalRHubs/RealtimeVehicle", {
//         transport: signalR.HttpTransportType.WebSockets,
//         accessTokenFactory: () => jwt
//     })
//     .configureLogging(signalR.LogLevel.Information)
//     .build();
export const connection = (jwt: string) => { 
    return new signalR.HubConnectionBuilder()
    // .withUrl("http://julia-dev.ap-southeast-1.elasticbeanstalk.com/SignalRHubs/RealtimeVehicle", {
    // .withUrl("http://julia-prod.ap-southeast-1.elasticbeanstalk.com/SignalRHubs/RealtimeVehicle", {
    .withUrl(`${process.env.REACT_APP_API_URL}/SignalRHubs/RealtimeVehicle`, {
    // .withUrl("https://localhost:5001/SignalRHubs/RealtimeVehicle", {
    // .withUrl("https://localhost:5005/SignalRHubs/RealtimeVehicle", {
    // .withUrl("https://joey-api-dev.woodlandstransport.solutions/SignalRHubs/RealtimeVehicle", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => jwt
    })
    .configureLogging(signalR.LogLevel.Information)
    .build();

//     async function start() {
//       try {
//           await conn.start();
//           console.log("SignalR Connected.");
//           conn.on("BroadcastRealtimeVehicle", (data: any) => {
//             console.log("BroadcastRealtimeVehicle", data);
//         });
//       } catch (err) {
//           console.log(err);
//           setTimeout(start, 5000);
//       }
//   };
  
//   // connection.onclose(start);
  
//   // Start the connection.
//   // start();
  

//   async function stop(callback: () => void) {
//     try {
//         conn.onclose(() => {
//             console.log("CONNECTION CLOSED");
//             conn.stop();
//             callback()
//         });
//     } catch (err) {
//         console.log(err);
//         setTimeout(start, 5000);
//     }
// };

  
//   async function broadcastRealtimeVehicle() {
//       try {
//           let result = await conn.invoke("BroadcastRealtimeVehicle", {
//               lat: 100,
//               lng: 100,
//               speed: 60
//           });
//           console.log("broadcast OK: " + result);
//       } catch (err) {
//           console.error(err);
//       }
//   }
  
//   async function JoinAssignmentGroup(assignmentId: any) {
//       try {
//           await conn.invoke("JoinGroup", "assignment:" + assignmentId);
//           console.log("Done");
//       } catch (err) {
//           console.error(err);
//       }
//   }
  
//   async function JoinGroup(groupName: any) {
//       try {
//           await conn.invoke("JoinGroup", groupName);
//           console.log("Done");
//       } catch (err) {
//           console.error(err);
//       }
//     }

//     return {
//     conn,
//         start,
//       stop,
//       broadcastRealtimeVehicle,
//       JoinAssignmentGroup,
//       JoinGroup,
//     }
  }
